import { cva, type VariantProps } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariantClassMap = {
  default:
    'bg-background !text-foreground  border-subdued hover:bg-accent',
  success: 'bg-success hover:bg-success/90',
  warn: 'bg-warn hover:bg-warn/90 !text-white',
  informational:
    'bg-background border-subdued hover:bg-accent !text-foreground',
  destructive: 'bg-destructive hover:bg-destructive/90',
  outline: 'bg-background border-subdued hover:bg-accent !text-foreground',
  primary: 'bg-button hover:bg-button/90 !text-button-foreground',
  secondary: 'bg-secondary hover:bg-secondary/80 text-secondary !text-foreground',
  ghost: 'bg-background/50 hover:bg-accent !text-foreground !border-transparent',
  link: 'underline-offset-4 hover:underline !text-primary',
}

export const buttonVariants = cva(
  // Transparent unless a variant sets a colour, so filled buttons have no grey outline.
  'disabled:opacity-50 me-2 my-1 button !border-[1px] border-transparent ' +
    'transition duration-150 inline-flex items-center justify-center whitespace-nowrap rounded ' +
    'text-sm !text-surface-0 font-medium ring-offset-background transition-colors focus-visible:outline-none ' +
    'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none ' +
    'disabled:opacity-50 px-5 py-2.5',
  {
    variants: {
      variant: buttonVariantClassMap,
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded px-3',
        lg: 'h-11 rounded px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
